import { render, staticRenderFns } from "./SparringRoundParticipantScore.vue?vue&type=template&id=ff777b60&scoped=true"
import script from "./SparringRoundParticipantScore.vue?vue&type=script&lang=js"
export * from "./SparringRoundParticipantScore.vue?vue&type=script&lang=js"
import style0 from "./SparringRoundParticipantScore.vue?vue&type=style&index=0&id=ff777b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff777b60",
  null
  
)

export default component.exports